import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
export function BonusSection() {
  return <section className="py-20 px-4 bg-[#080808] border-t border-gray-800" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-yellow/10 rounded-full text-brand-yellow font-bold text-sm uppercase tracking-wider mb-6" data-id="element-17">
            <Gift size={16} data-id="element-18" />
            Bonos Gratis
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-19">
            HOY: 2 BONOS GRATIS <br data-id="element-20" />
            <span className="text-brand-yellow" data-id="element-21">(Valor total: $149 USD)</span>
          </h2>
          
        </div>

        {/* Bonus Cards */}
        <div className="space-y-12 mb-16" data-id="element-22">
          {/* Bonus 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#111] rounded-2xl border border-brand-yellow/20 overflow-hidden flex flex-col md:flex-row" data-id="element-23">
            <div className="md:w-2/5 bg-[#1a1a1a] p-8 flex items-center justify-center border-b md:border-b-0 md:border-r border-gray-800" data-id="element-24">
              <img src="https://cdn.magicpatterns.com/uploads/6qGFvZiDL5k1ok5WKXbhDm/bonus1_(2).png" alt="Kit Express de Ingreso Extra" className="w-full max-w-[240px] shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-25" />
            </div>
            <div className="md:w-3/5 p-8 md:p-10" data-id="element-26">
              <div className="flex items-center justify-between mb-4" data-id="element-27">
                <span className="text-brand-yellow font-bold tracking-widest text-xs uppercase" data-id="element-28">
                  Bono #1
                </span>
                <span className="text-gray-500 line-through text-sm" data-id="element-29">
                  $97 USD
                </span>
              </div>
              <h3 className="font-display text-2xl font-bold text-white mb-4" data-id="element-30">
                Kit Express de Ingreso Extra (Día 1 Listo)
              </h3>
              <p className="text-gray-400 mb-6" data-id="element-31">
                <strong className="text-white" data-id="element-32">Lo que hace:</strong> te deja el
                Día 1 hecho en minutos.
              </p>
              <div className="bg-gray-900/50 rounded-xl p-5 mb-6 border border-gray-800" data-id="element-33">
                <p className="text-xs uppercase text-gray-500 font-bold mb-3" data-id="element-34">
                  Incluye:
                </p>
                <ul className="space-y-2" data-id="element-35">
                  {['Oferta en 1 frase (plantilla)', '1 post listo para publicar', 'MENSAJES listos (precio, cierre, seguimiento)', 'Checklist "Día 1" (ejecución rápida)'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-300" data-id="element-36">
                      <CheckCircle2 className="text-brand-yellow shrink-0 mt-0.5" size={16} data-id="element-37" />
                      <span data-id="element-38">{item}</span>
                    </li>)}
                </ul>
              </div>
              <p className="text-sm text-gray-400 italic border-l-2 border-brand-yellow pl-4" data-id="element-39">
                <strong className="text-white not-italic" data-id="element-40">
                  Para qué sirve:
                </strong>{' '}
                Para que no te quedes "pensando" y realmente publiques/ofrezcas
                hoy.
              </p>
            </div>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#111] rounded-2xl border border-brand-yellow/20 overflow-hidden flex flex-col md:flex-row" data-id="element-41">
            <div className="md:w-2/5 bg-[#1a1a1a] p-8 flex items-center justify-center border-b md:border-b-0 md:border-r border-gray-800" data-id="element-42">
              <img src="https://cdn.magicpatterns.com/uploads/uTJfFq1Xp8sEeWAeRgsgdo/bonus_2.png" alt="Respuestas que Cierran" className="w-full max-w-[240px] shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-43" />
            </div>
            <div className="md:w-3/5 p-8 md:p-10" data-id="element-44">
              <div className="flex items-center justify-between mb-4" data-id="element-45">
                <span className="text-brand-yellow font-bold tracking-widest text-xs uppercase" data-id="element-46">
                  Bono #2
                </span>
                <span className="text-gray-500 line-through text-sm" data-id="element-47">
                  $52 USD
                </span>
              </div>
              <h3 className="font-display text-2xl font-bold text-white mb-4" data-id="element-48">
                Respuestas que Cierran (Pack de MENSAJES + Objeciones)
              </h3>
              <p className="text-gray-400 mb-6" data-id="element-49">
                <strong className="text-white" data-id="element-50">Lo que hace:</strong> te da las
                palabras exactas para responder sin quedarte en blanco.
              </p>
              <div className="bg-gray-900/50 rounded-xl p-5 mb-6 border border-gray-800" data-id="element-51">
                <p className="text-xs uppercase text-gray-500 font-bold mb-3" data-id="element-52">
                  Incluye:
                </p>
                <ul className="space-y-2" data-id="element-53">
                  {['MENSAJES copiar/pegar para WhatsApp/Messenger', 'Respuestas para objeciones ("Está caro", "Lo voy a pensar")', 'Checklist "antes de enviar" para cerrar más fácil'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-300" data-id="element-54">
                      <CheckCircle2 className="text-brand-yellow shrink-0 mt-0.5" size={16} data-id="element-55" />
                      <span data-id="element-56">{item}</span>
                    </li>)}
                </ul>
              </div>
              <p className="text-sm text-gray-400 italic border-l-2 border-brand-yellow pl-4" data-id="element-57">
                <strong className="text-white not-italic" data-id="element-58">
                  Para qué sirve:
                </strong>{' '}
                Para responder rápido, con seguridad y sin regalar tu precio.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Value Summary Table */}
        <div className="max-w-lg mx-auto bg-[#111] rounded-xl border border-gray-800 overflow-hidden" data-id="element-59">
          <div className="bg-gray-900/50 p-4 border-b border-gray-800 text-center" data-id="element-60">
            <h4 className="font-bold text-white uppercase tracking-wider text-sm" data-id="element-61">
              Resumen del Valor
            </h4>
          </div>
          <div className="p-6 space-y-4" data-id="element-62">
            <div className="flex justify-between items-center text-gray-400" data-id="element-63">
              <span data-id="element-64">Bono #1 + Bono #2</span>
              <span className="line-through" data-id="element-65">$149 USD</span>
            </div>
            <div className="flex justify-between items-center text-xl font-bold text-white pt-4 border-t border-gray-800" data-id="element-66">
              <span data-id="element-67">Tu precio hoy</span>
              <span className="text-brand-yellow" data-id="element-68">$0 (GRATIS)</span>
            </div>
            <p className="text-xs text-center text-gray-500 mt-4" data-id="element-69">
              * Se desbloquean automáticamente al comprar el eBook principal.
            </p>
          </div>
        </div>
      </div>
    </section>;
}